module.exports = __webpack_public_path__ + "static/media/logoWhiteBig.c384269a.png";